export class AppConstants {
  public static readonly CONTACT_EMAIL_ADDRESS = 'contacto@borromeo.mx';
  public static readonly EMPTY_STRING = '';
  public static readonly FIVE_NUMBER = 5;
  public static readonly FOUR_STARS_MASK = '****';
  public static readonly OTP_SECONDS = 180;
  public static readonly OTP_SPINNER_NAME = 'otpSpinner';
  public static readonly SIX_NUMBER = 6;
  public static readonly THREE_STARS_MASK = '***';
  public static readonly TOAST_INDEX = 5000;
  public static readonly WEBSITE_URI = 'https://borromeo.mx';
  public static readonly ZERO_NUMBER = 0;
};